import { authenticatedFetch } from "./base";

const API_PATH = "/api/pushtemplates";

export const updateTemplate = (
  versionId,
  surveyInstanceId,
  languageId,
  type,
  htmlPart,
  commentsObj,
) => {
  var url = `${API_PATH}/version/${versionId}/survey/${surveyInstanceId}/languages/${languageId}/types/${type}`;

  return authenticatedFetch(url, {
    method: "PUT",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      htmlPart: htmlPart,
      comments: {
        commentText: commentsObj?.commentText,
        commentProtocolVersionId: commentsObj?.protocolVersionId,
        commentRelatedTaskUrl: commentsObj?.relatedTaskUrl,
        commentInvestigatorId: commentsObj?.investigatorId,
      },
    }),
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(function (template) {
      return template;
    });
};

export const sendTemplate = (
  versionId,
  surveyInstanceId,
  languageId,
  type,
  email,
) => {
  return authenticatedFetch(
    `${API_PATH}/version/${versionId}/survey/${surveyInstanceId}/languages/${languageId}/types/${type}/send`,
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        email: email,
      }),
    },
  )
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(function (result) {
      return result;
    });
};
